<template>
    <div class="context">
        <div class="header">
            <div class="btn_box">
                <div class="btn nomal_btn" @click="goBack">
                    <i class="el-icon-back"></i>
                    返回
                </div>
            </div>
            <div class="title">{{viewTitle}}</div>
        </div>

        <div class="main_box">
            <el-form ref="ruleForm" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="医生名称" prop="name">
                    <el-input class="width_220"
                              placeholder="请输入医生名称"
                              v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone">
                    <el-input class="width_220"
                              placeholder="请输入医生手机号"
                              v-model="form.phone"></el-input>
                </el-form-item>
                <el-form-item label="医生编码" prop="doctor_code">
                    <el-input class="width_220"
                              placeholder="请输入医生编码"
                              v-model="form.doctor_code"></el-input>
                </el-form-item>
                <el-form-item label="关联医院" prop="hospital_id">
                    <div class="hos_select_box" @click="open_dialog">
                        <span v-if="form.hospital">{{form.hospital}}</span>
                        <span style="color: #CCC4D6" v-else>请选择关联医院</span>
                        <i class="el-icon-arrow-down"></i>
                    </div>
                </el-form-item>
                <el-form-item label="科室" prop="office">
                    <el-input class="width_220"
                              placeholder="请输入科室"
                              v-model="form.office"></el-input>
                </el-form-item>
                <el-form-item label="职称" prop="profe_title">
                    <el-input class="width_220"
                              placeholder="请输入医生职称"
                              v-model="form.profe_title"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button v-if="viewTitle === '添加医生'" type="primary" @click="submitAdd">提交</el-button>
                    <el-button v-else type="primary" @click="submitEdit">提交</el-button>
                </el-form-item>
            </el-form>
        </div>

        <el-dialog title="关联医院"
                   :visible.sync="dialogVisible_doc"
                   :modal-append-to-body="false"
                   :close-on-click-modal="false"
                   :close-on-press-escape="false"
                   top="8vh"
                   width="600px">
            <div class="table_box">
                <div class="table_search">
                    <div>
                        <el-input v-model="hos_search_input"
                                  placeholder="请输入医院名称"
                                  @change="getHospital"
                                  clearable
                                  class="width_220"></el-input>
                    </div>
                    <div class="two">
                        <el-cascader class="width_220"
                                     placeholder="请选择省市"
                                     clearable
                                     v-model="hos_search_cascader"
                                     :options="city_list"
                                     :props="cascader_props"
                                     @change="getHospital"></el-cascader>
                    </div>
                </div>
                <el-table :data="tableData"
                          @row-dblclick="select_row"
                          empty-text="请输入搜索条件筛选数据"
                          width="100%"
                          height="500px">
                    <el-table-column type="index" width="60" label="序号"></el-table-column>
                    <el-table-column label="医院名称"
                                     show-overflow-tooltip
                                     prop="name"></el-table-column>
                    <el-table-column label="操作" width="90">
                        <template slot-scope="scope">
                            <el-button @click="select_row(scope.row)" size="mini">
                                选择
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="close_dialog()">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {clone} from "@/global/utils";
    export default {
        name: "addView",
        data() {
            const checkPhone = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请输入手机号！'))
                }
                let reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                if (reg.test(value)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的手机号！'))
                }
            };
            return {
                viewTitle: '添加医生',
                form: {
                    name: '',
                    phone: '',
                    doctor_code: '',
                    hospital: '',
                    hospital_id: '',
                    office: '',
                    profe_title: '',
                },
                rules: {
                    name: [{required: true, message: '请输入名称！', trigger: 'blur'}],
                    doctor_code: [{required: true, message: '请输入医生编码！', trigger: 'blur'}],
                    hospital_id: [{required: true, message: '请选择关联医院！', trigger: 'blur'}],
                    office: [{required: true, message: '请输入科室！', trigger: 'blur'}],
                    profe_title: [{required: true, message: '请输入职称！', trigger: 'blur'}],
                    phone: [{required: true, validator: checkPhone, trigger: 'blur'}],
                },

                hos_search_input: '',
                hos_search_cascader: [],
                cascader_props: {
                    expandTrigger: 'hover',
                    value: 'name',
                    label: 'name',
                    children: 'city_list',
                },

                dialogVisible_doc: false,
                tableData: []
            }
        },
        computed: {
            ...mapState('manageData', [
                'doctor_data'
            ]),
            ...mapState("comInformationData", [
                'city_list'
            ])
        },
        mounted() {
            if (this.doctor_data) {
                this.viewTitle = '编辑医生- ' + this.doctor_data.name;
                this.form = clone(this.doctor_data);
            } else {
                this.viewTitle = '添加医生';
                this.form = {
                    name: '',
                    phone: '',
                    doctor_code: '',
                    hospital: '',
                    hospital_id: '',
                    office: '',
                    profe_title: '',
                };
            }
        },
        methods: {
            goBack() {
                this.$emit('changeTopTab', 'tableView')
            },
            getHospital() {
                if (this.hos_search_input || this.hos_search_cascader.length > 0) {
                    let params = {
                        name: this.hos_search_input,
                        province: this.hos_search_cascader[0]?this.hos_search_cascader[0]:'',
                        city: this.hos_search_cascader[1]?this.hos_search_cascader[1]:'',
                        page_size: 1000,
                        page: 1
                    };
                    this.httpGet('/hospital', params).then(res => {
                        this.tableData = res.data.data_list;
                        if (res.data.total > 1000) {
                            this.$message.warning('医院数据搜索结果已超过1000条！请精确搜索条件')
                        }
                    })
                } else {
                    this.tableData = []
                }
            },

            close_dialog() {
                this.dialogVisible_doc = false
            },
            open_dialog() {
                this.dialogVisible_doc = true
            },

            select_row(row) {
                this.form.hospital = row.name;
                this.form.hospital_id = row.hospital_id;
                this.close_dialog()
            },

            submitAdd() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let params = {
                            ...this.form
                        };
                        this.httpPost('/doctor', params).then(res => {
                            this.$message.success("添加成功！");
                            this.goBack()
                        })
                    }
                })
            },
            submitEdit() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        let params = {
                            ...this.form
                        };
                        this.httpPut(`/doctor/${this.form.user_id}`, params).then(res => {
                            this.$message.success("更新成功！");
                            this.goBack()
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    $view_background: rgb(246, 247, 248);
    $btn_border: rgb(246, 247, 248);
    .context {
        width: 100%;
        height: 100%;
        background: $view_background;
        .header {
            width: 100%;
            line-height: 50px;
            padding: 0 15px;
            box-sizing: border-box;
            display: flex;
            border-bottom: 1px solid #ddd;
            .title {

            }
            .btn_box {
                padding-right: 20px;
                .btn {
                    margin-top: 10px;
                    border: 1px solid $btn_border;
                }
            }
        }

        .main_box {
            padding: 10px;

            .hos_select_box {
                width: 350px;
                border: 1px solid #DCDFE6;
                height: 40px;
                line-height: 40px;
                box-sizing: border-box;
                border-radius: 4px;
                background: #fff;
                display: flex;
                justify-content: space-between;
                padding: 0 15px;
                color: #606266;
                span, i {
                    align-self: center;
                }
            }
        }
    }
    .table_box {
        height: 100%;
        box-sizing: border-box;
        .table_search {
            padding: 3px 15px;
            background: #fff;
            display: flex;
            div {
                padding-bottom: 5px;
            }
            .two {
                padding-left: 5px;
            }
        }
        .table {
        }
    }
</style>